export const HUBSPOT_INLINE_CHAT_CONTAINER_ID = "sked-hubspot-chat-inline";
export const HUBSPOT_INLINE_CHAT_SELECTOR = `#${HUBSPOT_INLINE_CHAT_CONTAINER_ID}`;
export const SUPPORT_CHAT_OPEN_EVENT = "sked:support-chat-open";

export interface SupportChatOpenDetail {
  message?: string;
  helpChatTopic?: string;
}
